module.exports = __webpack_public_path__ + "img/12_fineStaff_kln.770c64e2.png";